import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Testimonio from "../components/TestimoniosCarrusel";
import { Image } from "antd";
import {  Typography } from '@mui/material';
import FormBook from '../components/FormBook'
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import Footer from "../components/Footer";



export default function Home() {
  const { pathname } = useLocation();

  const [visible, setVisible] = useState(false);

  const openPreview = () => {
    setVisible(true); // Abrimos el preview
  };


  const vehicle = [
    require("../img/Vehicles/vehicles-34.jpg"),
    require("../img/Vehicles/vehicles-32.jpg"),
    require("../img/Vehicles/vehicles-30.jpg"),



    require("../img/Vehicles/bg-slide.jpg"),
    require("../img/Vehicles/vehicles-1.jpg"),
    require("../img/Vehicles/vehicles-2.jpg"),
    require("../img/Vehicles/vehicles-3.jpg"),
    require("../img/Vehicles/vehicles-4.jpg"),
    require("../img/Vehicles/vehicles-5.jpg"),
    require("../img/Vehicles/vehicles-6.jpg"),
    require("../img/Vehicles/vehicles-8.jpg"),
    require("../img/Vehicles/vehicles-9.jpg"),


  ]

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      <div className="container-fluid topbar bg-secondary d-none d-xl-block w-100">
        <div className="container">
          <div
            className="row gx-0 align-items-center"
            style={{ height: "45px" }}
          >
            <div className="col-lg-6 text-center text-lg-start mb-lg-0">
              <div className="d-flex flex-wrap">
                <a  href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México" className="text-muted me-4"
                
                  target="_blank"
                        rel="noopener noreferrer"
                >
                  <i className="fas fa-map-marker-alt text-primary me-2"></i>
                  Our location
                </a>
                <a href="tel:+5216242302304" className="text-muted me-4"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-phone-alt text-primary me-2"></i>
                  +5216242302304
                </a>
                <a href="mailto:reservations@tigresstransport.com.mx" className="text-muted me-0"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-envelope text-primary me-2"></i>
                  reservations@tigresstransport.com.mx
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <div className="d-flex align-items-center justify-content-end">
                <a
                  href="https://www.facebook.com/profile.php?id=100091411777035"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                   target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
{/*                 <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-0"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid nav-bar sticky-top px-0 px-lg-4 py-2 py-lg-0">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link to="/" className="navbar-brand p-0">
              <img src="img/Logo.jpg" alt="Logo" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="fa fa-bars"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div className="navbar-nav mx-auto py-0">
                <Link to="/" className="nav-item nav-link  active">
                  Home
                </Link>
                <div className="nav-item dropdown">
                  <Link
                    href="#"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    About us
                  </Link>
                  <div className="dropdown-menu m-0">
                  <Link to="/about-us" className="dropdown-item">
                     About us
                    </Link> 

                    <Link
                      to="/private-transportation"
                      className="dropdown-item"
                    >
                      Private Transportation
                    </Link>
                 {/*    <Link to="/shared-shuttle" className="dropdown-item">
                      Shared Shutttle
                    </Link> */}
                    <Link to="/large-groups" className="dropdown-item ">
                      Large Groups
                    </Link>

                    <Link to="/gallery" className="dropdown-item">
                      Gallery
                    </Link>
                  </div>
                </div>
                <Link to="/destinations" className="nav-item nav-link ">
                  Destinations
                </Link>
                <Link to="/vehicles" className="nav-item nav-link">
                  Our Fleet
                </Link>
                <Link to="/reviews" className="nav-item nav-link">
                  Our Reviews
                </Link>
                <Link to="/contact-us" className="nav-item nav-link">
                Contact Us
                </Link>
              
             
              </div>
              <Link
                to="/book-now"
                className="btn btn-primary rounded-pill py-2 px-4"
              >
                Book Now
              </Link>
            </div>
          </nav>
        </div>
      </div>

      <div className="header-carousel ">
        <div
          id="carouselId"
          className="carousel slide "
          data-bs-ride="carousel"
          data-bs-interval="false"
        >
          <ol className="carousel-indicators">
            <li
              data-bs-target="#carouselId"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="First slide"
            ></li>
            <li
              data-bs-target="#carouselId"
              data-bs-slide-to="1"
              aria-label="Second slide"
            ></li>
          </ol>
          <div className="carousel-inner " role="listbox">
            <div className="carousel-item active">
              <img
                src={require("../img/Vehicles/bg-slide.jpg")}
                className="img-fluid w-100 "
                alt="First slide"
              />
              <div className="carousel-caption ">
                <div className="container py-5">
                  <div className="row g-5">
                    <div
                      className="col-lg-6 d-none d-lg-flex fadeInRight animated"
                      data-animation="fadeInRight"
                      data-delay="0.2s"
                      style={{ animationDelay: "0.2s" }}
                    >
                      <div className="text-start">
                        <h1 className="display-5 text-white">
                        Plan your trip with tigress tours and transport in los Cabos BCS México
                        </h1>
                      </div>
                    </div>
                    <div
                      className="col-lg-6 fadeInLeft animated "
                      data-animation="fadeInLeft"
                      data-delay="0.2s"
                      style={{ animationDelay: "0.2s", }}
                    >
              
                    
                 <FormBook/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
                 
                </div>
              </div>
            </div>
    

      <div className="container-beer py-5  ">
        <div
          className="img-aditional-container wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <img
            src={require("../img/services-aditional/bebidas.jpg")}
            className="img-aditional"
            alt="Image"
          />
          <p>Beer and water</p>
        </div>
        <div
          className="img-aditional-container wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <img
            src={require("../img/services-aditional/comestibles .jpg")}
            className="img-aditional"
            alt="Image"
          />
          <p>Grocery stop upon request</p>
        </div>
        <div
          className="img-aditional-container wow fadeInUp"
          data-wow-delay="0.5s"
        >
          <img
            src={require("../img/services-aditional/conduciendo.jpg")}
            className="img-aditional"
            alt="Image"
          />
          <p>Bilingual drivers</p>
        </div>
        <div
          className="img-aditional-container wow fadeInUp"
          data-wow-delay="0.7s"
        >
          <img
            src={require("../img/services-aditional/asiento-bebe.jpg")}
            className="img-aditional"
            alt="Image"
          />
          <p>Car seats upon request </p>
        </div>
      </div>

      <div className="container-fluid feature py-5">
        <div className="container py-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-5 text-capitalize mb-3">
              Tigress transport – Low Cost Airport Transfers
            </h1>
            <p className="mb-0">
              With our easy online reservation system, we have outdone our
              competitors just 2 clicks and your reservation is complete, we
              believe you should only have to input your reservation once. Your
              flight and hotel information is then entered into our
              sophisticated reservation system that our professionals are
              constantly monitoring.
            </p>
          </div>
          <div className="row g-4 align-items-center">
            <div className="col-xl-4">
              <div className="row gy-4 gx-0">
                <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                  <div className="feature-item">
                    <span className="fa fa-check fa-2x"></span>

                    <div className="ms-4">
                      <h5 className="mb-3">
                        Phone Customer Service Available 24/7
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-12 wow fadeInUp" data-wow-delay="0.3s">
                  <div className="feature-item">
                    <span className="fa fa-check fa-2x"></span>

                    <div className="ms-4">
                      <h5 className="mb-3">
                        Unlimited changes and free cancellations
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-12 col-xl-4 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <Image.PreviewGroup
                items={[
                  require("../img/Clientes/Selfie.jpg"),
                  require("../img/Clientes/Cliente-1.jpg"),
                  require("../img/Clientes/Cliente-2.jpg"),
                  require("../img/Clientes/Cliente-3.jpg"),
                  require("../img/Clientes/Cliente-4.jpg"),
                  require("../img/Clientes/Cliente-5.jpg"),
                  require("../img/Clientes/Cliente-6.jpg"),
                  require("../img/Clientes/Cliente-7.jpg"),
                  require("../img/Clientes/Cliente-8.jpg"),
                  require("../img/Clientes/Cliente-9.jpg"),
                  require("../img/Clientes/Cliente-10.jpg"),

                  require("../img/Clientes/Cliente-11.jpg"),

                  require("../img/Clientes/Cliente-12.jpg"),
                  require("../img/Clientes/Cliente-13.jpg"),

               


                ]}
                preview={{
                  visible: visible,
                  onVisibleChange: (value) => setVisible(value), // Cerramos el preview
                }}
              >
                <Image
                  src={require("../img/Clientes/Selfie.jpg")}
                  className="img-fluid w-100"
                  style={{ objectFit: "cover" }}
                  alt="Img"
                />
              </Image.PreviewGroup>
              <div className="col-12 py-2">
                <button
                  onClick={openPreview}
                  className="btn btn-primary w-100 py-2"
                >
                  View more
                </button>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="row gy-4 gx-0">
                <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                  <div className="feature-item justify-content-end">
                    <div className="text-end me-4">
                      <h5 className="mb-3">Grocery stops on request</h5>
                    </div>
                    <span className="fa fa-check fa-2x"></span>
                  </div>
                </div>
                <div className="col-12 wow fadeInUp" data-wow-delay="0.3s">
                  <div className="feature-item justify-content-end">
                    <div className="text-end me-4">
                      <h5 className="mb-3">Best price guarantee</h5>
                    </div>
                    <span className="fa fa-check fa-2x"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid blog margin-bottom-5 py-5">
        <div className="container">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-5 text-capitalize mb-3">
              Vehicles for all your transportation needs
            </h1>
          </div>
          <div className="row g-4">
            <div class=" d-flex flex-wrap justify-content-center gap-2 " >
                {vehicle&& vehicle.map((img, index) => (

                    <div
                    className="wow fadeInUp"
                    data-wow-delay={`0.${index +1}s`}
                    >

                <Image
                  width={400}
                  height={300}
                  src={img}
                  style={{objectFit: "cover"}}
               
                  />
                  </div>
           
                ))}

            </div>
          </div>
        </div>
      </div>




      <div className="container-fluid  ">
        <div className="container pb-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-5 text-capitalize mb-3">
              Our Clients<span className="text-primary"> Reviews</span>
            </h1>
            <Typography variant="body1" color="text.secondary">
        What our clients say about us.
        </Typography>
            <Testimonio />
          </div>
        </div>
      </div>
















      
<Footer/>
<ButtonWhatsapp/>
     
    </div>
  );
}
